import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../context';
import { RestClient } from '../lib';
import { useTry } from './useTry';

type SettingReqLabel = 'leaseAsset' | 'article' | 'book' | 'company' | 'mst';

function useSettingReq(label: SettingReqLabel) {
  const { tryReq } = useTry();
  const { tenantId } = useTenant();
  const navigate = useNavigate();

  const saveTemporarily = useCallback(
    async (contents: unknown) => {
      await tryReq(
        async () => {
          await RestClient.post('/setting?bodySize=$$large', {
            ctx: { tenantId },
            payload: {
              label,
              contents,
              confirm: false,
            },
          });
        },
        { successMsg: '一時保存しました' },
      );
    },
    [label, tenantId, tryReq],
  );

  const savePermanently = useCallback(
    async (contents: unknown, successMsg: string) => {
      await tryReq(
        async () => {
          await RestClient.post('/setting?bodySize=$$large', {
            ctx: { tenantId },
            payload: {
              label,
              contents,
              confirm: true,
            },
          });
          navigate('/setting');
        },
        { successMsg },
      );
    },
    [label, tenantId, tryReq, navigate],
  );

  return {
    saveTemporarily,
    savePermanently,
  };
}

export { useSettingReq };
export type { SettingReqLabel };
